import SVGInject from '@iconfu/svg-inject';

document.addEventListener('DOMContentLoaded', function () {
    SVGInject(document.querySelectorAll('.home-cta__button img'));
});
